import type { PayrollValueObjectsConceptCategoryEnum } from 'generated/resources/graphql'

import { DEFAULT_RESULT_CONCEPT } from 'modules/payroll_bundle/lib/constants'

/**
 * Helper to ensure the literals we pass are valid PayrollValueObjectsConceptCategoryEnum values.
 * If you typo one, TS will scream here.
 */
const makeCategoryList = <T extends PayrollValueObjectsConceptCategoryEnum[]>(...values: T) =>
  values

/**
 * Earnings concept categories (type-checked against the enum)
 */
const INCLUDED_EARNINGS_CONCEPT_CATEGORIES = makeCategoryList(
  'earnings_benefits_in_kind',
  'earnings_fixed_salary',
  'earnings_others',
  'earnings_variable'
)

/**
 * Deductions concept categories (type-checked against the enum)
 */
const INCLUDED_DEDUCTIONS_CONCEPT_CATEGORIES = makeCategoryList('deductions')

/**
 * Filter predicate for payroll concepts based on specific business rules:
 * 1. Include all earnings concepts except base_salary
 * 2. Only include the salary_advance deduction
 * 3. Exclude all other deductions
 */
export const filterPayrollConcepts = (payrollConcept: {
  name: string
  category?: string | null
}): boolean => {
  const { name, category } = payrollConcept

  if (!category) return false

  const isEarning = INCLUDED_EARNINGS_CONCEPT_CATEGORIES.some(
    (allowedCategory) => allowedCategory === category
  )

  const isDeduction = INCLUDED_DEDUCTIONS_CONCEPT_CATEGORIES.some(
    (allowedCategory) => allowedCategory === category
  )

  if (isEarning && name !== DEFAULT_RESULT_CONCEPT.base_salary) {
    return true
  }

  if (isDeduction && name === DEFAULT_RESULT_CONCEPT.salary_advance) {
    return true
  }

  return false
}
